export enum ParticipantSide {
    COORDINATOR = 'coordinator',
    INSPECTOR = 'inspector',
    DEFAULT = INSPECTOR
}